import Vue from 'vue';
import App from './App.vue';
import { sync } from 'vuex-router-sync';
import router from './router';
import VueMeta from 'vue-meta';

import store from './store';
import ApiService from './services/api.service';
import { TokenService } from './services/storage.service';
import i18n from './i18n'
import filters from './filters';
import BootstrapVue from './../node_modules/bootstrap-vue';
import Multiselect from 'vue-multiselect';
import VueLodash from './../node_modules/vue-lodash';
import VueResource from 'vue-resource';
import VuePaginator from 'vuejs-paginator';
/* import VeeValidate from 'vee-validate'; */
import CryptoJS from "crypto-js";
import VueAWN from "vue-awesome-notifications"
import lodash from "lodash";
import cookieconsent from 'vue-cookieconsent-component'

import VueGtag from "vue-gtag";
// import VueGtm from 'vue-gtm';

/* import VueGtm from 'vue-gtm'; */
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import browserDetect from "vue-browser-detect-plugin";


if (localStorage.getItem('app_version') !== process.env.VUE_APP_VERSION) {
    localStorage.setItem('app_version', process.env.VUE_APP_VERSION);
    window.location.reload(true);
}


if (!('locale' in localStorage)) {
    localStorage.setItem('locale', process.env.VUE_APP_I18N_LOCALE);
    localStorage.setItem('locale_label', process.env.VUE_APP_I18N_LANGUAGE_LABEL);
}

Vue.config.productionTip = false;

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

// If token exists set header
//if (TokenService.getToken()) {
ApiService.setHeader();
// } else {
//   TokenService.removeUserDetails();
// }

//Uses filters
Vue.use(filters);
Vue.use(BootstrapVue);
Vue.use(browserDetect);

/* Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors'
}); */

const options = { position: 'top-right' }; // customize the way you want to call it

Vue.use(VueLodash, { name: 'custom', position: 'top-right', lodash: lodash });

// Vue.use(VueLodash, options); // options is optional
Vue.use(VueResource);
Vue.use(VueAWN, options);
Vue.use(datePicker)

Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GOOGLE_TAG }
}, router);


// Vue.use(VueGtag, {
//     config: { id: "UA-49874520-3" }
//   }, router);

Vue.use(VueMeta, {
    keyName: 'metaInfo',
});

// Vue.use(VuePaginator)
Vue.component('multiselect', Multiselect);
Vue.component('bootstrap-alert', require('./components/Alert.vue').default);
Vue.component('VPaginator', VuePaginator);

Vue.component('cookie-consent', cookieconsent)

Vue.config.productionTip = false

const CryptoJSAesJson = {
    stringify: function (cipherParams) {
        var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
        if (cipherParams.iv) j.iv = cipherParams.iv.toString();
        if (cipherParams.salt) j.s = cipherParams.salt.toString();
        return JSON.stringify(j);
    },
    parse: function (jsonStr) {
        var j = JSON.parse(jsonStr);
        var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
        if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
        if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
        return cipherParams;
    }
}

Vue.mixin({
    data() {
        return {
            languages: [
                { 'value': 'en_GB', 'label': 'English', 'text': 'English' },
                { 'value': 'fi_FI', 'label': 'Suomi', 'text': 'Finnish' }
            ],
            userData: {},
            currencySign: process.env.VUE_APP_CURRENCY_SIGN,
            perPageCount: 10,
            TYPE_PRODUCT: 'product',
            base_url: process.env.VUE_APP_BASE_URL,

            carSelectedWidth: ('car_selected_width' in localStorage) ? parseInt(localStorage.getItem('car_selected_width')) : parseInt(process.env.VUE_APP_DEFAULT_CAR_WIDTH),
            carSelectedAspectRatio: ('car_selected_aspect_ratio' in localStorage) ? parseInt(localStorage.getItem('car_selected_aspect_ratio')) : parseInt(process.env.VUE_APP_DEFAULT_CAR_ASPECT_RATIO),
            carSelectedDiameter: ('car_selected_diameter' in localStorage) ? parseFloat(localStorage.getItem('car_selected_diameter')) : parseFloat(process.env.VUE_APP_DEFAULT_CAR_DIAMETER),
            carSelectedSeason: ('car_selected_season' in localStorage) ? localStorage.getItem('car_selected_season') : process.env.VUE_APP_DEFAULT_SEASON,

            vanSelectedWidth: ('van_selected_width' in localStorage) ? parseInt(localStorage.getItem('van_selected_width')) : parseInt(process.env.VUE_APP_DEFAULT_VAN_WIDTH),
            vanSelectedAspectRatio: ('van_selected_aspect_ratio' in localStorage) ? parseInt(localStorage.getItem('van_selected_aspect_ratio')) : parseInt(process.env.VUE_APP_DEFAULT_VAN_ASPECT_RATIO),
            vanSelectedDiameter: ('van_selected_diameter' in localStorage) ? parseFloat(localStorage.getItem('van_selected_diameter')) : parseFloat(process.env.VUE_APP_DEFAULT_VAN_DIAMETER),
            vanSelectedSeason: ('van_selected_season' in localStorage) ? localStorage.getItem('van_selected_season') : process.env.VUE_APP_DEFAULT_VAN_SEASON,

            truckSelectedWidth: ('truck_selected_width' in localStorage) ? parseInt(localStorage.getItem('truck_selected_width')) : parseInt(process.env.VUE_APP_DEFAULT_TRUCK_WIDTH),
            truckSelectedAspectRatio: ('truck_selected_aspect_ratio' in localStorage) ? parseInt(localStorage.getItem('truck_selected_aspect_ratio')) : parseInt(process.env.VUE_APP_DEFAULT_TRUCK_ASPECT_RATIO),
            truckSelectedDiameter: ('truck_selected_diameter' in localStorage) ? parseFloat(localStorage.getItem('truck_selected_diameter')) : parseFloat(process.env.VUE_APP_DEFAULT_TRUCK_DIAMETER),
            truckSelectedSeason: ('truck_selected_season' in localStorage) ? localStorage.getItem('truck_selected_season') : process.env.VUE_APP_DEFAULT_TRUCK_SEASON,
        }
    },
    created() {
        this.userData = localStorage.getItem('userDetails');
    },
    methods: {
        generateVueSlug(text, ampersand = 'and') {
            if (!text) {
                return
            }
            const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ';
            const b = 'aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh';
            const p = new RegExp(a.split('').join('|'), 'g');

            return text.toString().toLowerCase()
                .replace(/[\s_]+/g, '-')
                .replace(p, c =>
                    b.charAt(a.indexOf(c)))
                .replace(/&/g, `-${ampersand}-`)
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
                .replace(/^-+|-+$/g, '');
        },
        encrypt(encFld) {
            let secretData = CryptoJS.AES.encrypt(
                JSON.stringify(encFld),
                process.env.VUE_APP_ENCRYPTKEY,
                { format: CryptoJSAesJson }
            ).toString();

            secretData = JSON.parse(secretData);
            return secretData = secretData.s + "|||" + secretData.ct + "|||" + secretData.iv;
        },
        decrypt(encryptedVal) {
            return JSON.parse(
                CryptoJS.AES.decrypt(
                    encryptedVal,
                    process.env.VUE_APP_ENCRYPTKEY,
                    { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)
            );
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isIntegerNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;

            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        withCurrencySign(value) {
            return this.currencySign + ' ' + value
        },
        //Global method to check user has a permission for that route or not.
        _hasAccessOf(permission, userPermissions) {
            if (permission && userPermissions) {
                return _.some(userPermissions, { 'title': permission })
            }
            return true;
        },
        isPhoneNo: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            var inputValue = evt.target.value;

            if (
                (charCode > 31 && (charCode < 48 || charCode > 57)) && // Not a number
                charCode !== 43 && // Not a plus sign (+)
                charCode !== 32 && // Not a space
                charCode !== 45 && // Not a hyphen (-)
                charCode !== 40 && // Not an opening parenthesis (
                charCode !== 41 // Not a closing parenthesis )
            ) {
                evt.preventDefault();
            } else if (
                (charCode === 43 && inputValue.indexOf('+') !== -1) || // Prevent additional plus signs
                (charCode === 40 && inputValue.indexOf('(') !== -1) || // Prevent additional opening parentheses
                (charCode === 41 && inputValue.indexOf(')') !== -1) || // Prevent additional closing parentheses
                (charCode === 45 && inputValue.split('-').length > 3) || // Prevent additional hyphens
                (charCode === 32 && inputValue.split(' ').length > 4) // Prevent additional spaces
            ) {
                // Prevent additional plus signs
                evt.preventDefault();
            } else {
                return true;
            }
        },
        normalizeString(productName) {
            return productName.replace(/[ `~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-');
        },
        googleTagAddToCart: function (netprice, product) {

            this.$gtag.event('add_to_cart', {
                currency: "EUR",
                value: netprice,
                items: [{
                    'item_id': product.type_id,
                    'item_name': product.name,
                    // 'page_title': product.name,
                    'price': product.net_price,
                    // 'net_price': product.net_price,
                    // 'qty': product.qty,
                    'quantity': product.qty,
                    'type_id': product.type_id,
                    'item_category': product.car_type,
                    // 'model': product.model
                }]
            })
        },
        googleTagRemoveFromCart: function (product) {

            this.$gtag.event('remove_from_cart', {
                currency: "EUR",
                value: product.net_price,
                items: [{
                    'item_id': product.type_id,
                    'item_name': product.name,
                    // 'page_title': product.name,
                    'price': product.net_price,
                    // 'net_price': product.net_price,
                    // 'qty': product.qty,
                    'quantity': product.qty,
                    'type_id': product.type_id,
                }]
            })
        },
        googleTagViewCart: function (cartTotal, cartProductList) {
            this.$gtag.event("view_cart", {
                currency: "EUR",
                value: cartTotal,
                items: cartProductList
            });
        },
        googleTagPageDetails: function (pageName) {
            this.$gtag.event('page_details', {
                'page_title': pageName
            })
        },
        googleTagViewItems: function (product) {
            this.$gtag.event('view_item', {
                currency: "EUR",
                value: product.net_price,
                items: [{
                    'item_id': product.id,
                    'item_name': product.name,
                    'price': product.net_price,
                    'type_id': product.id,
                    'item_brand': product.brand_name,
                    'item_category': product.car_type
                }]
            })
        },
        googleTagViewItemList: function (gtag_products) {
            this.$gtag.event('view_item_list', {
                item_list_id: "related_products",
                item_list_name: "Related products",
                items: gtag_products
            })
        },
        googleTagSelectItem: function (product) {
            this.$gtag.event('select_item', {
                item_list_id: "related_products",
                item_list_name: "Related products",
                items: [{
                    'item_id': product.type_id,
                    'item_name': product.name,
                    // 'page_title': product.name,
                    'price': product.net_price,
                    // 'net_price': product.net_price,
                    // 'qty': product.qty,
                    'quantity': product.qty,
                    'type_id': product.type_id,
                    'item_category': product.car_type
                }]
            })
        },
        googleTagBeginCheckout: function (orderTotal, gtag_products) {
            this.$gtag.event("begin_checkout", {
                currency: "EUR",
                value: orderTotal,
                coupon: "",
                items: gtag_products
            });
        },
        googleTagAddPaymentInfo: function (paymentConfirmation, checkout_provider, gtag_products) {
            this.$gtag.event("add_payment_info", {
                currency: "EUR",
                value: paymentConfirmation.total,
                coupon: "",
                payment_type: checkout_provider,
                items: gtag_products
            });
        },
        googleTagPurchase: function (paymentConfirmation, shippingCharges, gtag_products) {
            this.$gtag.event("purchase", {
                transaction_id: paymentConfirmation.order_number,
                affiliation: "Webshop",
                value: paymentConfirmation.total,
                tax: paymentConfirmation.vat_amount,
                shipping: shippingCharges,
                currency: "EUR",
                coupon: "",
                items: gtag_products
            });
        },
        klaviyoTrackAddToCart(Product) {
            var _kl = window.klaviyo, URL = ''
            var BreadCrumbObject = this.makeBreadcrumbLink(Product)
            if (BreadCrumbObject.name) {
                var resolved = this.$router.resolve(BreadCrumbObject);
                URL = (`${process.env.VUE_APP_BASE_URL}${resolved.href}`).replace(/([^:]\/)\/+/g, '$1')
            }
            var Item = {
                ProductID: Product.id,
                ProductName: Product.name,
                Price: Product.net_price,
                Brand: Product.brand_name,
                Categories: Product.car_type,
                ImageURL: Product.image ? `${Product.image.image_base_path}${Product.image.path}` : '',
                URL: URL,
                SKU: Product.ean_number
            };
            console.log("Product - klaviyoTrackAddToCart", Product)
            console.log('Added to Cart', Item)
            _kl.push(['track', 'Added to Cart', Item])
        },
        klaviyoTrackViewedProduct(Product) {
            var _kl = window.klaviyo, URL = ''
            var BreadCrumbObject = this.makeBreadcrumbLink(Product)
            if (BreadCrumbObject.name) {
                var resolved = this.$router.resolve(BreadCrumbObject);
                URL = (`${process.env.VUE_APP_BASE_URL}${resolved.href}`).replace(/([^:]\/)\/+/g, '$1')
            }
            var Item = {
                ProductName: Product.name,
                ProductID: Product.id,
                SKU: Product.ean_number,
                Categories: Product.car_type,
                ImageURL: Product.image ? `${Product.image.image_base_path}${Product.image.path}` : '',
                URL: URL,
                Price: Product.net_price,
                Brand: Product.brand_name
            }
            console.log("Product - klaviyoTrackViewedProduct", Product)
            console.log("Product - Viewed Product", Item)

            _kl.push(['track', 'Viewed Product', Item])
        },
        klaviyoStartedCheckout(OrderDetails) {
            var _kl = window.klaviyo, t = this
            const orderId = OrderDetails.id; // Replace with dynamic order/session ID
            const timestamp = Date.now(); // Get current timestamp in milliseconds
            const eventId = `${orderId}_${timestamp}`;
            var resolved = this.$router.resolve({ name: 'order-summary', params: { orderNumber: OrderDetails.order_number } });
            var CheckoutURL = (`${process.env.VUE_APP_BASE_URL}${resolved.href}`).replace(/([^:]\/)\/+/g, '$1')

            var Items = [], ItemNames = [], Categories = []
            this.orderDetails.line_items.forEach(function (product) {
                if (product.type == "product") {
                    var Product = product.product, ProductUrl = ''
                    var BreadCrumbObject = t.makeBreadcrumbLink(Product)
                    if (BreadCrumbObject.name) {
                        var resolved = t.$router.resolve(BreadCrumbObject);
                        ProductUrl = (`${process.env.VUE_APP_BASE_URL}${resolved.href}`).replace(/([^:]\/)\/+/g, '$1')
                    }
                    var Item = {
                        ProductID: Product.id,
                        SKU: Product.ean_number,
                        ProductName: Product.name,
                        Quantity: product.quantity,
                        ItemPrice: parseFloat(product.unit_price),
                        RowTotal: (parseFloat(product.unit_price) * product.quantity).toFixed(2),
                        ProductURL: ProductUrl,
                        ImageURL: Product.image ? `${Product.image.image_base_path}${Product.image.path}` : '',
                        Categories: Product.car_type,
                        Brand: Product.brand_name
                    }
                    Items.push(Item)
                    ItemNames.push(Product.name)
                    Categories.push(Product.car_type)
                }
            })
            var Data = {
                "$event_id": eventId,
                "$value": OrderDetails.total,
                "ItemNames": ItemNames,
                "CheckoutURL": CheckoutURL,
                "Categories": Categories,
                "Items": Items
            }
            _kl.push(["track", "Started Checkout", Data])
        },
        klaviyoIdentifyUser(Email) {
            var _kl = window.klaviyo, UserEmail = Email || null;
            if (this.loggedIn) {
                var UserDetails = TokenService.getUserDetails()
                _kl.identify({ email: UserDetails.email });
            } else {
                if (UserEmail !== null) {
                    _kl.identify({ email: UserEmail });
                } else {
                    this.klaviyoReset()
                }
            }
        },
        klaviyoReset() {
            var _kl = window.klaviyo;
            _kl.reset();
            document.cookie = '__kla_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            document.cookie = 'kl_csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            if ("__kl_key" in localStorage) {
                localStorage.removeItem("__kl_key");
            }
        },
        setPrebuildThumbnail(event) {
            event.target.setAttribute('src', `${this.base_url}images/no-data-found.png`)
        },
        showAvailableSlotsCommon(dealerservice) {
            try {
                let availableDays = [];
                if (dealerservice.time_slots) {
                    for (let availableDay in dealerservice.time_slots) {
                        availableDays[availableDay] = _.upperFirst(dealerservice.time_slots[availableDay].day)
                    }
                    return _.join(availableDays, ', ')
                }
            } catch (error) {
                console.log("showAvailableSlots", error.message)
                return null;
            }

        },
        availableSlotDayCommon(dealerservice) {
            try {
                let availableDays = this.showAvailableSlotsCommon(dealerservice)
                let days = []
                if (availableDays) {
                    days = availableDays.split(', ');
                }
                return days;
            } catch (error) {
                console.log("availableSlotDay", error.message);
                return null;
            }

        },
        nextAvailableSlotDateCommon(dealerService) {
            try {
                let days = this.availableSlotDayCommon(dealerService)
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                // 15th two months prior
                const minDate = today
                let weekdays = [];
                if (this.currentLang != 'en_GB') {
                    weekdays = [
                        'Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'
                    ];
                } else {
                    weekdays = [
                        'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
                    ];
                }


                let count = 0, length = 4, month, dm, tempDate;
                // Order Monday first possibility to booking time on Thrusday
                // Order Tuesday first possibility to booking time on Friday
                // Order Wednesday first possibility to book time on Monday
                // Order Thursday first possibility to book time on Tuesday
                // Order Friday first possibility to book time on Wednesday
                // Order weekend first possibility to book time on Wednesday
                // Order public holiday first possibility to book time on 3th working day

                for (let i = 1; i < length; i++) {
                    minDate.setDate(minDate.getDate() + 1)
                    // check for weekend
                    while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                        minDate.setDate(minDate.getDate() + 1)
                        // check for holiday
                        while (this.holidays.includes(tempDate)) {
                            minDate.setDate(minDate.getDate() + 1)
                            month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                            dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                            tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                        }
                    }
                    month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                    dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                    tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                    // check for holiday
                    while (this.holidays.includes(tempDate)) {
                        minDate.setDate(minDate.getDate() + 1)
                        // check for weekend
                        while (_.indexOf(days, weekdays[minDate.getDay()]) == -1) {
                            minDate.setDate(minDate.getDate() + 1)
                        }
                        month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                        dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                        tempDate = minDate.getFullYear() + '-' + month + '-' + dm
                    }
                }

                if (!this.appointmentDate || this.appointmentDate == null) {
                    let month = minDate.getMonth() + 1 < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1)
                    let dm = minDate.getDate() < 10 ? '0' + (minDate.getDate()) : +(minDate.getDate())
                    this.appointmentDate = minDate.getFullYear() + '-' + month + '-' + dm
                }

                let defaultAllowedTimes = []
                for (let timeSlot in dealerService.time_slots) {
                    let day = dealerService.time_slots[timeSlot].day
                    defaultAllowedTimes[day] = []
                    defaultAllowedTimes[day]['slots'] = []
                    defaultAllowedTimes[day]['start_time'] = dealerService.time_slots[timeSlot].start_time
                    defaultAllowedTimes[day]['end_time'] = dealerService.time_slots[timeSlot].end_time
                    let start = defaultAllowedTimes[day]['start_time'].split(':')
                    let end = defaultAllowedTimes[day]['end_time'].split(':')
                    let i = start[0];
                    for (i = parseInt(start[0]); i <= parseInt(end[0]); i++) {
                        let hour = i
                        if (i < 10) {
                            hour = "0" + i
                        }
                        if (parseInt(start[1]) >= parseInt("00")
                            && parseInt(start[1]) < parseInt("30")) {
                            defaultAllowedTimes[day]['slots'].push(hour + ':' + '00')
                        }
                        if (i < parseInt(end[0]) ||
                            (parseInt(end[0]) == i && parseInt(end[1]) >= parseInt("30"))) {
                            defaultAllowedTimes[day]['slots'].push(hour + ':' + '30')
                        }
                    }
                }

                let nextTimeSlot = '';
                if (defaultAllowedTimes[weekdays[minDate.getDay()]]['slots'][0]) {
                    nextTimeSlot = defaultAllowedTimes[weekdays[minDate.getDay()]]['slots'][0];
                }

                //this.allowedTimeOptions = this.getAllowedTimes(this.allowedTimes, this.appointmentDate)
                return minDate.getDate() + '-' + (minDate.getMonth() + 1) + '-' + minDate.getFullYear() + ' ' + nextTimeSlot;
            } catch (error) {
                //console.log("nextAvailableSlotDate2", "dealerService", dealerService);
                console.log("error", error)
                console.log("error", error.message)
                return null;
            }
        },
        formatPrice(price) {
            let format = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price)
            return format;
        },
        rimSize(rim) {
            if (rim) {
                return rim + ' ' + this.$t("Inch")
            }
        },
        rimSizeIcon(rim) {
            if (rim) {
                return rim + '”'
            }
        },
        goToError() {
            window.scrollTo(0, 0);
        },
        makeBreadcrumbLink(product) {
            try {
                var load_index = (product.load_index && product.load_index.replace(/\s*\(.*?\)\s*/g, '').replace('/', '_')) || ''
                var speed_index = (product.speed_index && product.speed_index.replace(/\s*\(.*?\)\s*/g, '')) || ''
                var reinforced = product.reinforced
                var route_name = this.currentLang === 'en_GB' ? 'single_product' : 'single_product_fi';

                var params = {
                    vehicle_type: this.currentLang === 'en_GB' ? product.tyre_category.slug_en : product.tyre_category.slug_fi,
                    tyre_season: this.currentLang === 'en_GB' ? product.tyre_season.slug : product.tyre_season.slug_fi,
                    tyre_size: (product.width + '-' + product.aspect_ratio + '-r' + product.diameter),
                    brand: this.currentLang === 'en_GB' ? product.brand.slug : product.brand.slug_fi,
                    model: this.currentLang === 'en_GB' ? product.model.slug : product.model.slug_fi
                }

                if (load_index !== '' && parseInt(load_index) > 0) {
                    var li_si = load_index
                    if (speed_index !== '') {
                        li_si += speed_index
                    }
                    params.load_speed_index = li_si

                    if (reinforced && reinforced !== 'No') {
                        params.reinforced = reinforced
                    }
                }

                return { name: route_name, params: params }
            } catch (e) {
                return { "message": e.message }
            }

        },
        go_to_products(vehicle_type, query, replace) {
            var route_name = this.currentLang === 'en_GB' ? 'product_list_by_vehicle_type' : 'product_list_by_vehicle_type_fi'
            var route = {
                name: route_name
            }
            if (vehicle_type) {
                route.params = { vehicletype: vehicle_type }
            }
            if (query) {
                route.query = query
            }
            if (replace) {
                route.replace = replace
            }
            return route
        }
    }
});

//Sync vue-router's current $route as part of vuex store's state.
sync(store, router);
/* Vue.use(VueGtm, {
  id: 'GTM-NHP52WD', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
}); */

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
            el.setAttribute('data-dragging', 'yes');
        }
        el.eventClearDrag = function () {
            el.removeAttribute('data-dragging');
        }
        el.eventOnClick = function (event) {
            var dragging = el.getAttribute('data-dragging');
            // Check that the click was outside the el and its children, and wasn't a drag
            if (!(el == event.target || el.contains(event.target)) && !dragging) {
                // call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
    }, unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
    },
});

new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
}).$mount('#app');
